import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemeConstantService } from '../shared/services/theme-constant.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ResourceService } from '../resource-service.service';
import { WebService } from '../shared/services/web.service';
import { AwsService } from '../shared/services/aws-service';

import { FolderNavigationService } from '../shared/services/folder-navigation.service';
import { NewResourceComponent } from '../new-resource/new-resource.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import * as momentz from 'moment-timezone';
import { environment } from 'src/environments/environment';
import { fadeIn } from '../../app/shared/animation/animation.component';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  CdkDragPlaceholder,
  CdkDragMove,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { tryCatch } from 'rxjs/internal-compatibility';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { clone, get } from 'lodash';
import { isThisSecond } from 'date-fns';


interface DataItem {
  popularity: string;
  resource_name: string;
  size: string;
  group_names: string[];
  uploaded_date: string;
  expires_date: string;
  category_name: string;
  tag: any;
  checked: any;
  position: number;
  is_shareable: boolean;
}

interface ColumnItem {
  key:string,
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
  sortKey?: string;
  colWidth: any;
  Showsort?: boolean;
}
export interface VirtualDataInterface {
  index: number;
  resource_name: string;
  resource_id: number;
  position: number;
}

interface ResourceData {
  resource_id: string;
  resource_name: string;
  parent_folder: string | null;
  is_folder: boolean;
  resource_path: string;
  resource_url: string;
  resource_path_url: string;
  resource_thumbnail: string;
  size: number;
  is_active: boolean;
  document_notes: string;
  uploaded_date: string;
  expires_date: string;
  position: number;
  category_id: string;
  category_name: string;
  category_description: string;
  tag: { tag_id: string; tag_name: string }[];
  group_names: string[];
  is_deleted: boolean;
  mixedState?: boolean; // for checkbox state
  checked?: boolean; // for checkbox state
  is_shareable?: boolean; // for shareable state
  index?: number; // for table index
}

interface ResourceNode {
  resource_id: string;
  parent_id: string | null; // alias for parent_folder
  type: 'folder' | 'file' | 'image' | 'pdf' | 'url'; // you can derive this from extension if needed
  children?: string[]; // list of resource_ids
  data: ResourceData;
}

 interface FolderPaginationState {
  currentPage: number;
  totalPages: number;
  loadedResourceIds: string[]; // only resource_ids, not full data
  isLoading?: boolean;         // optional: if async
  isLastPage?: boolean;        // optional: for UI disabling scroll
  nextPage: number | null;
}

@Component({
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.css'],
  animations: [fadeIn],
  
})
export class ResourceComponent{
  themeColors = this.colorConfig.get().colors;
  colorRed = this.themeColors.red;
  colorBlue = this.themeColors.blue;
  colorCyan = this.themeColors.cyan;
  colorGold = this.themeColors.gold;
  colorVolcano = this.themeColors.volcano;
  colorPurple = this.themeColors.purple;
  quickViewVisible: boolean;
  visible: boolean = false;
  allChecked: boolean = false;
  indeterminate: boolean = false;
  selectedFile: string = '';
  quickViewDetail: boolean = false;
  visibleDetail: boolean = true;
  detailVisible: any;
  pdfSrc: SafeResourceUrl;
  name = 'Angular';
  data: any = [];
  iconVisible: boolean = false;
  filteredFiles: any = [];
  selectedRootFolder: any;
  resourcesList: any;
  resourceFolderForm: FormGroup;
  selectedTagValues: any = [];
  checkedItems: any = [];
  anyChecked: any;
  tableDataRaw: any = [];
  arrangedFiles = {};
  showFilter: boolean;
  filterVisible: boolean;
  tagList: any;
  tagFilterList: any[];
  createFolderVisible: boolean;
  metadata: any;
  resource_category: any;
  resources: any[] = [];
  folderName: string = '';
  currentFolderId: number | null = null;
  isCategoryAutofilled: boolean = false;
  navigationStack: any = [];
  updateMode: boolean;
  updateModes: boolean;
  resourceForm: FormGroup<any>;
  resourceData: DataItem[];
  resourceDataRaw: any;
  resourceId: any;
  metadatas: any;
  knowledgeBasesList: any;
  knowledgeBasesLists: any;
  editId: any;
  // pageSize: Number = 20;

  dragDropLimit: number = 10;
  dragDropApiCount: number = 1;
  position: number = 1;
  currentPage: number = 1;
  isFileSyncingStatus: boolean = false;
  lastFileSyncTime: string = '';
  hasMore:boolean = true;
  BUCKET_URL = environment.BUCKET_URL;
  previousIndex: number;

  @ViewChild(NewResourceComponent) newResourceComponent: NewResourceComponent;
  @ViewChild('popoverContent') popoverContent: ElementRef;
  // @ViewChild('popoverContent') popoverContent: ElementRef;
  // @ViewChild('popoverContent') contentTemplate!: ElementRef;
  // @ViewChild('resourcesListTable', { static: false }) nzTableComponent?: NzTableComponent<any>;
  @ViewChild('resourcesListTable', { static: false }) nzTableComponent?: NzTableComponent<VirtualDataInterface>;
  @ViewChild('resourcesListTable', { static: false }) nzTableRef: any;

  @ViewChild('tableContainer', { static: false }) ResourceTableRef?: NzTableComponent<any>;
 
  @ViewChild('scrollContainer') scrollContainerRef!: ElementRef;
  fillEditResourceData: any;
  uploadedImgUrl: any;
  rawUpdateData: any;
  parentFolder: { resource_id: any; children: any };
  folderStack: any = [];
  originalResourcesList: any[];
  original: any;
  searchHistory: any;
  filteredResourcess: any[] = [];
  tableData: any = [];
  navigationHistory: any[] = [];
  searchTerm: any;
  sortName: string;
  sortValue: string;
  updateResourceId: any;
  isLoading: boolean = false;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  resourceCopy: any;
  tagMetaData: any;
  resourceDetail: any;
  loadingSwitch: boolean = false;
  isUsedInLast30Days: any;
  active: any;
  archived: any;
  showMoreGroups: boolean = false;
  showLoad: boolean = false;
  appliedFilters: any[];
  url: string;
  file: File;
  isUrl: boolean;
  isFile: boolean;
  thumbnailBaseURL: string = environment.BUCKET_URL;
  positionOptions: any;
  itemsPerPage: number = 25; // Default items per page
  initialLoad: boolean = true;
  lastRequestTime: string = '';
  resourceCache: Map<string, ResourceNode> = new Map();
  folderPaginationMap: Map<any, FolderPaginationState> = new Map();
  folderNavigationStack: string[] = [null]; // start at root
  folderIndexMap = new Map<number | null, number>();
  // Stack to track navigation history
  scrollPositionMap = new Map<string, number>(); // folderId -> scrollTop
  currentBrowserTimeZone: string = "";
  sortField: string | null = null;
  sortOrderR: 'asc' | 'desc' | null = null;
  currentResourceCount: number = 0;

  private destroy$ = new Subject<boolean>();
  constructor(
    private colorConfig: ThemeConstantService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private resourceService: ResourceService,
    private webapi: WebService,
    private fb: FormBuilder,
    private folderNavigationService: FolderNavigationService,
    private notification: NzNotificationService,
    private modal: NzModalService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private awsService: AwsService
  ) {
    this.resourceFolderForm = fb.group({
      resource_name: [null, [Validators.required]],
      tag: [null],
      position: [1, [Validators.required]],
    });
    this.currentBrowserTimeZone = momentz.tz.guess();
    console.log("Current Browser Time Zone:", this.currentBrowserTimeZone);

    this.getResourceList({ filters: [] });
    this.syncProcessStatus();
    this.getMetadata();

    // this.getResources();
    // {filters: []}

    // Listen for changes in position field
    this.resourceFolderForm.get('position')?.valueChanges.subscribe(value => {
      console.log('Rank value changed:', value);
      // this.resourcePosition(value);
    });
  }
  
  scrollToIndex(index: number): void {
    this.nzTableComponent?.cdkVirtualScrollViewport?.scrollToIndex(index);
    console.log('Scrolling to index:', index);
  }

  trackByIndex(_: number, data: VirtualDataInterface): number {
    return data.resource_id;
  } 

  intervalId: any = null; // Declare at component level

  syncProcessStatus() {
    try {
      this.webapi.requestJson('syncProcessStatus', {}).subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          console.log("This is response", response);
          const status = response.data.status;

          if (status === 'in_progress') {
            this.isFileSyncingStatus = true;
            //Add the lastProcessTime
            this.lastFileSyncTime = response.data.started_at || '';
            console.log("Last File Sync Time:", this.lastFileSyncTime);

            // Only set interval if it's not already set
            if (!this.intervalId) {
              console.log("Syncing in progress, setting interval to check status");

              this.intervalId = setInterval(() => {
                this.syncProcessStatus();
              }, 15000);
            }
          } else {

            
            // Sync is completed or failed
            this.isFileSyncingStatus = false;

            //Add the lastProcessTime
            this.lastFileSyncTime = response.data.completed_at || '';
            console.log("Last File Sync Time:", this.lastFileSyncTime);

            // Clear interval if it exists
            if (this.intervalId) {
              console.log("Syncing completed or failed, clearing interval");
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          
          }

          console.log("this is file syncing status", this.isFileSyncingStatus);
        },
        (error) => {
          this.isLoading = false;
          this.createNotification(
            'error',
            '',
            'An error occurred. Please try again later.'
          );
        }
      );
    } catch (error) {
      console.error("Error in syncProcessStatus", error);
    }
  }

  // ngAfterViewInit(): void {
  //   this.nzTableComponent?.cdkVirtualScrollViewport?.scrolledIndexChange
  //     .pipe(
  //       debounceTime(100), 
  //       takeUntil(this.destroy$))
  //     .subscribe((index: number) => {
  //       console.log('scroll index to', index); 
  //       const threshold = 4; // Start loading more when 5 items from the end
  //       const totalItems = this.filteredResourcess?.length ?? 0;
  //       console.log("this is total items",totalItems);
  //       console.log("this is threshold",threshold);
  //       console.log("this is filtered Resource while scroll",this.filteredResourcess);


  //       if (this.initialLoad) {
  //         this.initialLoad = false; // Skip scroll-based trigger once
  //         return;
  //       }

  //       if (index >= totalItems - threshold && !this.isLoading) {
  //         this.loadNextPage();
        
  //         console.log("call next api")
  //       }
  //     });
  //   console.log("calling something")
    
  // }



   loadNextPage(resourceId?, page?):void {
    if (this.isLoading || this.noMoreData){
      console.log("Already loading or no more data to load");
      return;
    } 
    //  this.currentPage = this.folderPaginationMap.get(this.selectedRootFolder || null)?.currentPage || 1;  

    this.isLoading = true;
    console.log("this is selected root folder into loadnext", this.selectedRootFolder)
   
     let isLastPage = this.folderPaginationMap.get(this.selectedRootFolder || null)?.isLastPage || false;  
     let nextPage = this.folderPaginationMap.get(this.selectedRootFolder || null)?.nextPage || false;  

    this.lastRequestTime = localStorage.getItem('lastRequestTime');

     console.log(" nextPage:", nextPage);
     this.currentPage = nextPage ? nextPage : this.currentPage;
     console.log("Current Page:", this.currentPage , "isLastPage :", isLastPage);

     //call the getResourceList function with updated page number
     if (!isLastPage){
      // this.selectedRootFolder = resourceId ? resourceId : this.getCurrentFolderId();
      this.getResourceList({ filters: [] }, this.lastRequestTime);
    }
    else{
      console.log("Starting LoadNext Error printing ===========>")
      console.log("this.hasMore", this.hasMore);
      console.log("this.isLoading", this.isLoading);
      console.log("this.folderPaginationMap", this.folderPaginationMap);
      console.log("this.selectedRootFolder", this.selectedRootFolder);

       console.log("End LoadNext Error printing ===========>")

      this.isLoading = false;
      // this.createNotification('info', '', 'No more data to load.');
      // this.folderNavigationStack.length > 1 && this.folderNavigationStack.pop() ;
     
    }



  }
  ngOnDestroy(): void {
    console.log("ngDestroy called");
    // Clean up the destroy subject to prevent memory leaks
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  confirmModal?: NzModalRef; // For testing by now
  showConfirm(hideQuickViewVisible: boolean = false): void {
    this.confirmModal = this.modal.confirm({
      nzTitle:
        'All unsaved changes will be lost. Do you wish to proceed with closing the form?',
      nzContent: '',
      nzCentered: true,
      nzOnOk: () => {
        if (hideQuickViewVisible) {
          this.quickViewVisible = !this.quickViewVisible;
        }

        this.createFolderVisible = false;
      },
    });
  }
  syncFilesConfirmationModal?: NzModalRef; // For testing by now
  syncFileConfirmation():void{
    this.syncFilesConfirmationModal = this.modal.confirm({
      nzTitle: 'Start Sync Process?',
      nzContent: 'Syncing may take hours to complete. You can keep using the application during the process.',
      nzCentered: true,
      nzOnOk: () => {
       // Call the api function here
        this.syncFilesSubmit();
      },
    });
  }
  isHeatersFolderExist(){
    let heaterFolder = this.resourcesList.find(
      (resource) => resource.parent_folder === null && resource.resource_name.toLowerCase() === 'heaters'
    );
    if(heaterFolder){
      return heaterFolder;
    }
    else{
      return null;
    }
  }
  //Check if heaters folder exist or not & handle accordingl

   
      
      

      

  //Submit to sync the files
  syncFilesSubmit(){

    this.isLoading = true;
    console.log("this is sync file request");
    
    this.webapi.requestJson('syncFileRequest', {}).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
   
        this.createNotification('success', '', response['message']);
        this.isFileSyncingStatus = true;
        this.isLoading = false;

        this.syncProcessStatus();
       
      },
      (error) => {
        this.isLoading = false;
        this.createNotification(
          'error',
          '',
          'An error occurred. Please try again later.'
        );
      }
    );
    
     

   
    
  }

  originalFormValue: any;
  checkFormState() {
    if (this.isFormNotEmpty()) {
      this.showConfirm();
      return;
    }
    this.createFolderVisible = false;
  }
  // Method to set the original form value before patchValue is called
  setOriginalFormValue(): void {
    this.originalFormValue = { ...this.resourceFolderForm.value };
  }

  // Updated hasFormChanged() method to check for value differences
  hasFormChanged(): boolean {
    if (!this.originalFormValue) {
      return false; // No original form value to compare (form not patched yet)
    }

    const formControls = this.resourceFolderForm.controls;
    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = this.originalFormValue[controlName];
        const currentValue = formControls[controlName].value;
        if (originalValue != currentValue) {
          return true; // Found a difference in form values
        }
      }
    }

    return false; // No differences found in form values
  }

  isFormNotEmpty(): boolean {
    if (this.resourceFolderForm.controls) {
      if (this.hasFormChanged()) return true;
      else return false;
    } else {
      for (const controlName in this.resourceFolderForm.controls) {
        if (this.resourceFolderForm.controls.hasOwnProperty(controlName)) {
          const control = this.resourceFolderForm.get(controlName);
          if (control && control.value !== null && control.value !== '') {
            return true; // Form control has a non-empty value
          }
        }
      }
      return false; // No form control has a non-empty value
    }
    // Check if any form control has a non-empty value
  }

  async ngOnInit() {
    //Different logic
    this.positionOptions = Array.from({ length: 100 }, (_, i) => i + 1);

    //Trigger every time when query params call iteself
    this.route.queryParams.subscribe((params) => {
      console.log('this function has been called');
      const folderId = +params['folderId']; // '+' to convert string to number
      if (!isNaN(folderId)) {
        console.log("this is folderID and typeof", folderId, typeof folderId);

        const isAlreadyCached = this.folderPaginationMap.has(folderId);
        console.log("this is folder pagination mapp", this.folderPaginationMap)

        console.log("isAlreadyCached", isAlreadyCached);
        this.selectedRootFolder = folderId;
        if (isAlreadyCached) {
          console.log("this is cached resource", folderId);
          this.renderData(() => {
            // After DOM is updated, restore scroll
            setTimeout(() => {
              const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
              this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
            }, 0); // adjust delay if necessary
          });
          console.log("after render data", this.filteredResourcess)
        } else {
          let resource_id = folderId;
          // let page = 1;
          this.selectedFolder = folderId;
          this.currentPage = 1; // Reset to first page when navigating to a folder
          console.log('need to call api');
          this.getResourceList({ filters: [] }, this.lastRequestTime);
          // this.loadNextPage(resource_id, page); // page 1
        }

        // this.filteredResourcess = this.resourcesList.filter(
        //   (resource) => resource.parent_folder === folderId
        // );

        // this.filteredResourcess.forEach((resource, index) => {
        //   resource['index'] = index + 1;
        // });


      } else {
        // this.filteredResourcess = this.resourcesList.filter(
        //   (resource) => resource.parent_folder === null
        // );
        // this.filteredResourcess.forEach((resource, index) => {
        //   resource['index'] = index + 1;
        // });
        this.selectedRootFolder = null;
        let folderId = null;
        const isAlreadyCached = this.folderPaginationMap.has(null);

        console.log("isAlreadyCached", isAlreadyCached);

        if (isAlreadyCached) {
          console.log("this is cached resource", folderId);
          this.renderData(() => {
            // After DOM is updated, restore scroll
            setTimeout(() => {
              const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
              this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
            }, 0); // adjust delay if necessary
          });
          console.log("after render data", this.filteredResourcess)
        } else {
          let resource_id = folderId;
          let page = 1;
          console.log('need to call api');
          this.loadNextPage(resource_id, page); // page 1
        }

      }

      this.handleAllCheckstate(this.filteredResourcess);
      //Due to this handleAllcheckstate function the checkbox alway return true
      // this.handleAllCheckstate(this.filteredResourcess);
    });
    // this.navigationHistory.push(this.router.url);
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.navigationHistory.push(event.url);
    //   }
    // });
    // if (
    //   this.newResourceComponent &&
    //   this.newResourceComponent.resetResourceForm
    // ) {
    //   this.newResourceComponent.resetResourceForm();
    // }
    // const unsafeUrl = 'assets/files/pdf-sample.pdf';
    // this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
    // this.folderNavigationService.getCurrentFolderId().subscribe((folderId) => {
    //   if (folderId !== null) {
    //     this.currentFolderId = folderId;
    //   }
    // });
    // console.log('this is initial message');
  }


  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     const scrollContainer = this.tableRef?.nzScroll?.y
  //       ? this.tableRef?.elementRef?.nativeElement?.querySelector('.ant-table-body')
  //       : null;

  //     if (scrollContainer) {
  //       scrollContainer.addEventListener('scroll', this.onTableScroll.bind(this));
  //     }
  //   }, 0);
  // }


  onPopoverVisibleChange(visible: boolean) {
    if (!visible) {
      this.clickFilter();
    } else {
      console.log('Popover is now visible');
    }
  }
  isArchived: boolean = false;

  listOfColumns: ColumnItem[] = [
    {
      key: 'position',
      name: 'Order',
      Showsort: true,
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        // console.log("a==>",a);
        // console.log("b==>",b);
        // console.log("this is position", a.position, b.position);
        const nameA = a.position;
        const nameB = b.position;
        return nameA - nameB;
      },
      sortDirections: ['ascend', 'descend'],
      colWidth: '10%',
      // 100px
    },
    {
      key: 'resource_name',
      name: 'Name',
      Showsort: true,
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const nameA = a.resource_name || '';
        const nameB = b.resource_name || '';
        return nameA.localeCompare(nameB);
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '30%',
    },
    {
      key: 'catgory_name',
      name: 'Category',
      sortOrder: null,
      Showsort: true,
      sortFn: (a: DataItem, b: DataItem) => {
        const nameA = a.category_name || '';
        const nameB = b.category_name || '';
        return nameA.localeCompare(nameB);
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '15%',
      // 200px
    },
    {
      key: 'is_active',
      Showsort: false,
      name: 'Active',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
      colWidth: '13%',
      //20px
    },

    {
      key: 'uploaded_date',
      name: 'Uploaded',
      Showsort: true,
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const createdA = a.uploaded_date || '';
        const createdB = b.uploaded_date || '';
        const nameComparison = createdA.localeCompare(createdB);

        if (nameComparison !== 0) {
          return nameComparison;
        }

        const dateA = new Date(a.uploaded_date).getTime();
        const dateB = new Date(b.uploaded_date).getTime();

        return dateA - dateB;
      },
      sortDirections: ['ascend', 'descend', null],
      colWidth: '15%',
      // 200px
    },

    // {
    //   name: 'Popularity',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) => {
    //     const nameA = a.popularity || '';
    //     const nameB = b.popularity || '';
    //     return nameA.localeCompare(nameB);
    //   },
    //   sortDirections: ['ascend', 'descend', null],
    //   colWidth: '8%',
    //   // 100px
    // },
    {
      key: 'Shareable',
      Showsort: false,
      name: 'Share',
      sortOrder: null,
      sortFn: null,
      sortDirections: null,
      colWidth: '12%',
    },
    // {
    //   key: 'Tags',
    //   name: 'Tags',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) => {
    //     const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
    //     const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
    //     return tagA.localeCompare(tagB);
    //   },
    //   sortDirections: ['ascend', 'descend', null],
    //   colWidth: '',
    // },
    // {
    //   name: 'Size',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) => {
    //     const nameA = a.size || '';
    //     const nameB = b.size || '';
    //     return nameA.localeCompare(nameB);
    //   },
    //   sortDirections: ['ascend', 'descend', null],
    //   colWidth: '8%',
    //   // 100px
    // },
    {
      key: 'Assignment',
      name: 'Assignment',
      Showsort: false,
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
      // sortFn: (a: DataItem, b: DataItem) => {
      //   const nameA = a.group_names.map((group) => group).join(', ') || '';
      //   const nameB = b.group_names.map((group) => group).join(', ') || '';
      //   return nameA.localeCompare(nameB);
      // },
      // sortDirections: ['asc', 'desc', null],
      colWidth: '20%',
    },

    {
      key: 'Actions',
      name: 'Actions',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
      colWidth: '100px',
      // 150px
    },
  ];
  receiveFormFromChild(newResource){
    console.log("this is event from child", newResource);
    this.currentPage = 1; // Reset to first page after deletion
    this.selectedRootFolder = this.getCurrentFolderId(); // Reset selected root folder
    this.getResourceList({ filters: [] });

    // this.appendResourceIntoCurrentList(newResource);
    // let resourceExist = this.resourceCache.has(newResource.resource_id);
    // if(resourceExist){
    //   this.updateResource(newResource);
    // }
    // else{

    //   this.addResource(newResource);
    // }
    
  }

  addResource(resourceItem: any) {
    console.log("resourceItem in addresource function", resourceItem);
    const isFolder = resourceItem.is_folder;
    const parentId = resourceItem.parent_folder;

    const newNode: ResourceNode = {
      resource_id: resourceItem.resource_id,
      parent_id: parentId,
      type: isFolder ? 'folder' : 'file',
      children: isFolder ? [] : undefined,
      data: resourceItem,
    };
    console.log("This is newNode", newNode);
    this.resourceCache.set(newNode.resource_id, newNode);

    const parentState = this.folderPaginationMap.get(parentId || null);
    console.log("this is parent state", parentState);

    if (parentState) {
      parentState.loadedResourceIds.push(newNode.resource_id);
      console.log("PAGINATION HAS UPDATED")
    }
    console.log("updatedFolder paginationMap", this.folderPaginationMap);
  }
 updateResource(updatedItem: any) {
  const existing = this.resourceCache.get(updatedItem.resource_id);
  console.log("previous resource", existing);
  if (existing) {
    existing.data = { ...existing.data, ...updatedItem };
  }
   console.log("updated resource ---->", existing);

}

  appendResourceIntoCurrentList(resource) {
    const index = this.filteredResourcess.findIndex(res => res.resource_id === resource.resource_id);

    if (index !== -1) {
      // Resource exists
      const existing = this.filteredResourcess[index];

      // Update the object directly
      this.filteredResourcess[index] = { ...existing, ...resource };
    } else {
      // Resource doesn't exist, push new
      this.filteredResourcess.push(resource);
    }

    // Sort and update index
    this.filteredResourcess = [...this.filteredResourcess.sort((a, b) => a.index - b.index)];
    
    this.filteredResourcess = this.filteredResourcess.map((resource, index) => {
        return { ...resource, index: index + 1 };
      })
      
 
    console.log("resource updated", this.filteredResourcess);
  }

  getMetadata(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.webapi
        .requestJson('getMetaData', {
          metadata: ['resource_category', 'resource_tags'],
        })
        .subscribe(
          (data) => {
            let response = JSON.parse(data.body);
            this.metadata = cloneDeep(response.data);
            // this.resourceCopy = this.metadata.resourceData;
            // this.resourcesList = this.metadata.resourceData.filter(
            //   (resource) => resource.is_deleted === 0
            // );
            // this.filteredResourcess = this.resourcesList.filter(
            //   (resource) => resource.parent_folder === null
            // );
            // this.tableDataRaw = cloneDeep(this.filteredResourcess);

            // this.route.queryParams.subscribe((params) => {
            //   const folderId = +params['folderId']; // '+' to convert string to number

            //   if (!isNaN(folderId)) {
            //     this.filteredResourcess = this.resourcesList.filter(
            //       (resource) => resource.parent_folder === folderId
            //     );

            //     this.selectedRootFolder = folderId;
            //   } else {
            //     this.filteredResourcess = this.resourcesList.filter(
            //       (resource) => resource.parent_folder === null
            //     );
            //     this.selectedRootFolder = null;
            //   }
            // });

            if (this.metadata.resourceTagCategory) {
              this.tagMetaData = this.metadata.resourceTagCategory;
              this.tagList = [...this.tagMetaData];
              this.tagFilterList = [];
              this.tagList.forEach((element) => {
                this.tagFilterList.push({
                  text: element.name,
                  value: element.tag_id,
                  byDefault: false,
                });
              });
            }
            if (this.metadata.resourceCategory) {
              this.resource_category = this.metadata.resourceCategory;
            }

            resolve();
          },

          (error) => {
            // this.isLoading = false;
            // this.createNotification('error', '', 'An error occurred. Please try again later.');
            var msg = error.headers.get('message');
            reject();
          }
        );
    });
  }

  rootResources = [];

  displayFiles(resource: any) {
  
    // if (resource.is_folder) {
    //   this.router.navigate([], {
    //     relativeTo: this.route,
    //     queryParams: { folderId: resource.resource_id },
    //     queryParamsHandling: 'merge',
    //   });

    //   //check if parent folder is null then set root folder reference otherwise set the parentFolder;
    //   const queryP = resource.parent_folder ? `/resources?folderId=${resource.parent_folder}`: `/resources`;
    //   this.navigationHistory.push(queryP);
    // } else {
    if (!resource.is_folder) {
      // this.resourceService
      // .getResourceRecordsById(resource.resource_id)
      // .then((records) => {
      // this.router.navigate(['/resources', resource.resource_id]);
      this.router.navigate(['/resources', resource.resource_id]);

      // if(resource.resource_path_url && resource.resource_path_url !== ''){

      //   //Pass direct resource URL
      //   this.router.navigate(['/resources', resource.resource_path_url]);
      // }
      // else if(resource.resource_path && resource.resource_path !== ''){
      //   this.router.navigate(['/resources', `${this.BUCKET_URL}resource.resource_path`]);
      // }
      // else{
      //   //pass the URL file 
      //   this.router.navigate(['/resources', resource.resource_url]);
      // }


    // })
    // .catch((error) => {
    //   console.error('Error fetching resource records:', error);
    // });
    }
    this.searchTerm = '';

    const scrollTop = this.scrollContainerRef.nativeElement.scrollTop;
    this.scrollPositionMap.set(this.selectedRootFolder, scrollTop);
  // }
  }

  startEdit(id: string): void {
    this.editId = id;
    this.previousIndex = this.filteredResourcess.findIndex(item => item.resource_id === id);
    console.log('This is previous index', this.previousIndex);
  }

  stopEdit(currentIndex, event, resource): void {
    this.isLoading = true;
    this.editId = null;

     moveItemInArray(
          this.filteredResourcess,
        this.previousIndex,
          currentIndex - 1
        );

    this.resetIndex();
    console.log('This is resource after updating index', this.filteredResourcess);

    //Call reorder api to update the position (NEED TO CHECK THIS)
    this.reorderResource(resource.resource_id, currentIndex);
     console.log('This is event', event);
    this.isLoading = false;
    this.previousIndex = null;
  }

  onEnter(event: KeyboardEvent, currentIndex: number, resource: any): void {
    event.preventDefault(); // prevents blur from auto-firing
    this.stopEdit(currentIndex, event, resource);
  }

  getCurrentFolderId(): string {
  if (!this.folderNavigationStack || this.folderNavigationStack.length === 0) {

    return this.folderNavigationStack[this.folderNavigationStack.length - 1];
  }
  else{
    //fetch the folderId from query string path
    const currentFolderId = this.route.snapshot.queryParamMap.get('folderId');
    // console.log("this is currentfolderId in getcurrentFolder", currentFolderId)
    return currentFolderId ? currentFolderId : null;
  }
  }
  goToFolder(folderId: string | null) {
    if (!this.folderNavigationStack) {
      this.folderNavigationStack = [];
    }

    const idToPush = folderId ?? null;
    this.folderNavigationStack.push(idToPush);

  }
  
  
  updatePagination(folderId:number | null, page: number, totalPages: number, newResourceIds: string[]) {
    const current = this.folderPaginationMap.get(folderId || null);
    console.log("this is current folder pagination map", this.folderPaginationMap);

    const updated = {
      currentPage: page,
      totalPages,
      nextPage: page < totalPages ? page + 1 : null,
      loadedResourceIds: current
        ? [...current.loadedResourceIds, ...newResourceIds]
        : [...newResourceIds],
      isLastPage: page >= totalPages,
    };
    if (folderId != null && typeof folderId == 'string') {
      folderId = parseInt(folderId, 10);
    }
    
    console.log("this is updated folder pagination map", folderId);
    this.folderPaginationMap.set(folderId, updated);
    console.log("this is updated folderPaginationMap", this.folderPaginationMap);
  }

  displayFolder(resource: any) {

    //step 1: check is resource is folder or not
    // if (resource.is_folder) {
    //   this.selectedRootFolder = resource.resource_id;
    //   this.currentPage = 1; // Reset to first page when navigating to a file
    //   console.log("this is selectedRootFolder", this.selectedRootFolder);
    //   this.getResourceList({ filters: [] }, this.lastRequestTime);
    // }
    console.log("this is navigation history", this.navigationHistory);

    //reset the search box
    this.searchTerm = '';


    if (resource.is_folder) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { folderId: resource.resource_id },
        queryParamsHandling: 'merge',
      });
      // debugger;
      console.log('filteredresourcess', this.filteredResourcess);
      // this.handleAllCheckstate();
      //check if parent folder is null then set root folder reference otherwise set the parentFolder;
      const queryP = resource.parent_folder
        ? `/resources?folderId=${resource.parent_folder}`
        : `/resources`;
      this.navigationHistory.push(queryP);
      const scrollTop = this.scrollContainerRef.nativeElement.scrollTop;
      this.scrollPositionMap.set(this.selectedRootFolder, scrollTop);
    }
    
    
  }

  onFolderClick(resource) {
    
     console.log("this is selectedRootFolder inside folder", this.selectedRootFolder);
     this.currentPage = 1; // Reset to first page when navigating to a folder

     this.goToFolder(resource.resource_id); // push to folderNavigationStack
      this.displayFolder(resource)
     console.log("this is folderNavigationStack", this.folderNavigationStack);
     const isAlreadyCached = this.folderPaginationMap.has(resource.resource_id);

     console.log("isAlreadyCached", isAlreadyCached);

    if (isAlreadyCached) {
      console.log("this is cached resource",resource);
      this.renderData(() => {
        // After DOM is updated, restore scroll
        setTimeout(() => {
          const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
          this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
        }, 0); // adjust delay if necessary
      });
      console.log("after render data",this.filteredResourcess)
    } else {
      let resource_id = resource.resource_id;
      let page = 1;
      console.log('need to call api');
      // this.loadNextPage(resource_id, page); // page 1
    }
    //Reset state
    //  this.resetStateAfterNavigation()
  }

  renderData(callback?: () => void) {
    this.isLoading = true;
    this.filteredResourcess = []
    console.log("this is display folder function called");

    let currentFolderId = this.folderNavigationStack[this.folderNavigationStack.length - 1];
    console.log("this is currentFolder Id", currentFolderId);

    if( !currentFolderId) {
      currentFolderId = this.selectedRootFolder || null;
    }

    this.selectedRootFolder = currentFolderId; 
    console.log("this is selectedRootFolder", this.selectedRootFolder);

    console.log("this is folder pagination map", this.folderPaginationMap);
    const folderState = this.folderPaginationMap.get(currentFolderId);
    console.log("this is folderState", folderState);

    const visibleIds = folderState?.loadedResourceIds ?? [];

    //remove duplicate ids from visibleIds
    const uniqueVisibleIds = Array.from(new Set(visibleIds));

    const tableData = uniqueVisibleIds.map(id => this.resourceCache.get(id)?.data).filter(Boolean);
    console.log("this is tableData",tableData);

    this.filteredResourcess = tableData.sort((a, b) => a.position - b.position);
    // this.filteredResourcess.forEach((resource, index) => {
    //   // resource['index'] = index + 1;

    // })

   
    this.handleAllCheckstate(this.filteredResourcess);
    callback();//scroll back 
    this.isLoading = false;


  }
  handleAllCheckstate(currentResourceData) {
    //Becuase it return true even when array is empty [].every((e)=> e.checked) is true
    this.allChecked = currentResourceData.length > 0 && currentResourceData.every(e => e.checked === true);

    this.anyChecked = currentResourceData.length > 0 &&  currentResourceData.some((e) => e.checked);
    console.log("currentResourceData", currentResourceData);
    console.log('handle function called', this.allChecked);

    // if (this.allChecked) {
    //   this.indeterminate = false;
    // }
    // else {
    //   this.indeterminate = this.anyChecked && !this.allChecked;
    // }
  }
  getBreadcrumbs(): any[] {
    const currentNavigation = this.router.getCurrentNavigation();
    if (
      currentNavigation &&
      currentNavigation.extras &&
      currentNavigation.extras.state &&
      currentNavigation.extras.state.breadcrumbs
    ) {
      return currentNavigation.extras.state.breadcrumbs;
    }
    return [];
  }

  goBack() {
    console.log("this is selected folder", this.selectedRootFolder);

    // Reset to first page when navigating back according pagination map stack
    this.currentPage = this.folderPaginationMap.get(this.selectedRootFolder)?.currentPage || 1;
    this.searchTerm = ''

    // ============  OLD LOGIC   ================
    console.log("this is navigation history", this.navigationHistory);
    // this.navigationHistory.pop();

    const previousUrl = this.navigationHistory.pop();

    if (previousUrl) {
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigate(['/']);
    }
    // this.handleAllCheckstate();
    // ============  OLD LOGIC   ================

    if (this.folderNavigationStack.length > 1) {
      this.folderNavigationStack.pop();
      console.log("this is folder navigation", this.folderNavigationStack)
      this.selectedRootFolder = this.folderNavigationStack[this.folderNavigationStack.length - 1];

      //Check if data is available or need to fetch

      this.renderData(() => {
        // After DOM is updated, restore scroll
        setTimeout(() => {
          const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
          this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
        }, 0); // adjust delay if necessary
      });
    }
    else{
      // this.folderNavigationStack = ["null"];
      console.log("this is folder else navigation", this.folderNavigationStack)
      if(this.folderNavigationStack.length === 1){
        this.selectedRootFolder = null;
        this.renderData(() => {
          // After DOM is updated, restore scroll
          setTimeout(() => {
            // After DOM is updated, restore scroll
            setTimeout(() => {
              const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
              this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
            }, 0); // adjust delay if necessary
          }); // adjust delay if necessary
        });
      }
      else{
        //Maybe page reloaded and foldernavigation stack has empty so just call the root folder page 1 data
        this.selectedRootFolder = null;
        this.folderIndexMap.clear();
        this.folderPaginationMap.clear();
        this.scrollPositionMap.clear();
        this.resourceCache.clear();
        this.currentPage = 1; // Reset to first page when navigating to root folder
        this.getResourceList({ filters: [] }, this.lastRequestTime);
        this.renderData(() => {
          // After DOM is updated, restore scroll
          setTimeout(() => {
            const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
            this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
          }, 0); // adjust delay if necessary
        });
      }
      

    }

  }

  // buildResourceHierarchy(data) {
  //   this.original = [...data];

  //   const resourcesMap = new Map();

  //   data.forEach((item) => {
  //     const resourceId = item.resource_id;
  //     const parentFolder = item.parent_folder;

  //     const resource = {
  //       resource_id: resourceId,
  //       resource_name: item.resource_name,
  //       is_folder: item.is_folder,
  //       parent_folder: item.parent_folder,
  //       resource_path: item.resource_path,
  //       resource_url: item.resource_url,
  //       size: item.size,
  //       uploaded_date: item.uploaded_date,
  //       expires_date: item.expires_date,
  //       category_id: item.category_id,
  //       category_name: item.category_name,
  //       tag: item.tag || [],
  //       user:
  //         item.first_name && item.last_name
  //           ? [`${item.first_name} ${item.last_name}`]
  //           : [],
  //       group_names: item.group_names,
  //     };

  //     if (parentFolder === null) {
  //       this.rootResources.push(resource);
  //     }

  //     resourcesMap.set(resourceId, resource);

  //     if (parentFolder !== null) {
  //       const parentResource = resourcesMap.get(parentFolder);
  //       if (parentResource) {
  //         if (!parentResource.children) {
  //           parentResource.children = [];
  //         }
  //         parentResource.children.push(resource);
  //       }
  //     }
  //   });

  //   return this.rootResources;
  // }

  getResourceList({ filters }, lastRequestTime?,reqSource?): void {
    console.log("this.selectedRootFolder",this.selectedRootFolder);

    this.selectedRootFolder = this.selectedRootFolder ? this.selectedRootFolder : this.getCurrentFolderId();
    let sortObj = {};
    if(this.sortOrderR && this.sortField){
      sortObj = {
        sortField: this.sortField,
        sortOrder:this.sortOrderR
      }
    }
    // this.selectedRootFolder = null;
    this.showLoad = true;
    this.isLoading = true;
    // let currentPage = this.folderPaginationMap.get(this.selectedRootFolder)?.nextPage || 1;
    let currentLevelExistingResourcesIds = this.folderPaginationMap.get(this.selectedRootFolder)?.loadedResourceIds || [];
    console.log("this is current level existing resources", currentLevelExistingResourcesIds);
    console.log("CURRENT PAGE", this.currentPage);
   
    const obj = {
      request_page: this.currentPage,
      items_per_page:this.itemsPerPage,
      search: this.searchTerm || "",
      sort: sortObj ? sortObj : null,
      parent_id: this.selectedRootFolder,
      timestamp:lastRequestTime || "",
      existing_resources: currentLevelExistingResourcesIds || [],
      filters: filters.map((file) => {
        return {
          Key: file.key,
          Values: file.values,
        };
      }),
    }
    //if search is not provided then set it to empty string
    if (!reqSource || reqSource !== 'search') {
      obj.search = ""

    }
    console.log("this is getResource Obj", obj);
    this.webapi
      .requestJson('getPaginatedResource',  obj)
      .subscribe(
        (data) => {
          try {
          let response = JSON.parse(data.body);
          this.resourcesList = [...response.data.data];
        
          if (this.resourcesList.length < this.itemsPerPage) this.hasMore = false;
          console.log("this is resourceList after get resource",this.resourcesList);
        
           
          //===========  NO NEED TO CONCAT  ===========

            const parentFolder = this.resourceCache.get(obj.parent_id)?.data;

            // Start from previous index or 0
            let currentIndex = this.folderIndexMap.get(obj.parent_id) ?? 0;

            // console.log("this is currentIndex", currentIndex);

            this.resourcesList.forEach((resource) => {
              // resource['index'] = ++currentIndex;

              if(parentFolder?.checked){
                resource['checked'] = true;
                resource['mixedState'] = false;
              }
              else{
                resource['checked'] = false; // Initialize checked state
                resource['mixedState'] = false; // Initialize mixed state
              }
             
          });


            // console.log("this is currentIndex after loop", currentIndex);

          console.log("this is resourceList", this.resourcesList);

         
            // Save the updated index count
            // if(typeof obj.parent_id == 'string'){

            //   this.folderIndexMap.set(parseInt(obj.parent_id), currentIndex);
            // }
            // else{
            //   this.folderIndexMap.set(obj.parent_id, currentIndex);

            // }
            // console.log("this is folderIndexMap", this.folderIndexMap);

 
            const newResourceIds = [];

            // 🔹 Initialize filteredResourcess for first page
            if (this.currentPage === 1) {
              this.filteredResourcess = [];
            }

            const resp: any[] = [...this.resourcesList];
            resp.forEach((item)=>{
              //If resource already exist then replace the previous one with new one
              const isFolder = item.is_folder;

              const node: ResourceNode = {
                resource_id: item.resource_id,
                parent_id: item.parent_folder,
                type: isFolder ? 'folder' : 'file', // can expand with mime later
                children: isFolder ? [] : undefined, // we’ll fill this after fetching children
                data: item,
              };

              // Check if already in resourceCache
              const existingNode = this.resourceCache.get(item.resource_id);
              if (!existingNode) {
                //  New resource, insert into cache and track
                this.resourceCache.set(item.resource_id, node);
                newResourceIds.push(item.resource_id);
              } else {
                //  Already exists → replace the old one (update logic)
                this.resourceCache.set(item.resource_id, node);
                //Atleast add the resource id to newResourceIds to update pagination
                  newResourceIds.push(item.resource_id);

              }
              // Deduplicate filteredResourcess
              if (!this.filteredResourcess.some(r => r.resource_id === item.resource_id)) {
                this.filteredResourcess.push(item);
              }
             
              
            })
            console.log("this is resourceCache",this.resourceCache);
            let totalPages = Math.ceil(response.data.total_resources_count / this.itemsPerPage);

            console.log("this is search obj", obj.search)

            //Update pagination only when the search is empty

            if(!obj.search || obj.search == "" || obj.search == null){
              console.log("Updating the pagination in the getResourcelist")
              this.updatePagination(
                obj.parent_id,
                obj.request_page,
                totalPages,
                newResourceIds
              );
            }

            if(obj.sort == null || Object.keys(obj.sort).length === 0){
              //If no sort applied then sort by position
            // Update the filteredResourcess to reflect current folder's loaded resources
            this.filteredResourcess = this.filteredResourcess.sort((a, b) => a.position - b.position);
            }
            // else{
            //   this.filteredResourcess = [...this.filteredResourcess]
            // }
            this.currentResourceCount = this.filteredResourcess.length;
            console.log("Current RESOURCE COUNT ",this.currentResourceCount);

          // this.resourcesList = this.buildResourceHierarchy(this.resourcesList);
          // this.tableDataRaw = cloneDeep(this.filteredResourcess);
          
           

            //set the total resource count in local storage
            localStorage.setItem('totalResourceCount', response.data.total_resources_count.toString());
            localStorage.setItem('lastRequestTime', response.data.timestamp.toString());
            this.currentPage = this.currentPage + 1 ; // Increment the current page for next API call
            this.isLoading = false;
            this.showLoad = false;
          } catch (error) {
            console.log(error);
            this.isLoading = false;
            this.showLoad = false;
            this.createNotification('error', '', 'An error occurred while processing the data.');

          }

          // this.route.queryParams.subscribe((params) => {
          //   console.log('this function has been called');
          //   const folderId = +params['folderId']; // '+' to convert string to number
          //   if (!isNaN(folderId)) {
          //     this.filteredResourcess = this.resourcesList.filter(
          //       (resource) => resource.parent_folder === folderId
          //     );

          //     this.filteredResourcess.forEach((resource, index) => {
          //       resource['index'] = index + 1;
          //     });

          //     this.selectedRootFolder = folderId;
          //   } else {
          //     this.filteredResourcess = this.resourcesList.filter(
          //       (resource) => resource.parent_folder === null
          //     );
          //     this.filteredResourcess.forEach((resource, index) => {
          //       resource['index'] = index + 1;
          //     });
          //     this.selectedRootFolder = null;
          //   }
          //   this.handleAllCheckstate(this.filteredResourcess);
          // });

        },
        (error) => {
          this.showLoad = false;
          console.log('ERROR', error);
        }
      );
  }

  getSyncResource(): void {
    this.showLoad = true;
    this.webapi
      .requestJson('getResource', {})
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.resourcesList = [...response.data];

          this.filteredResourcess = this.resourcesList.filter(
            (resource) => resource.parent_folder === null
          );
          this.filteredResourcess.forEach((resource, index) => {
            resource['index'] = index + 1;
          });

          // this.resourcesList = this.buildResourceHierarchy(this.resourcesList);

          this.tableDataRaw = cloneDeep(this.filteredResourcess);

          // this.route.queryParams.subscribe((params) => {
          //   console.log('this function has been called');
          //   const folderId = +params['folderId']; // '+' to convert string to number
          //   if (!isNaN(folderId)) {
          //     this.filteredResourcess = this.resourcesList.filter(
          //       (resource) => resource.parent_folder === folderId
          //     );

          //     this.filteredResourcess.forEach((resource, index) => {
          //       resource['index'] = index + 1;
          //     });

          //     this.selectedRootFolder = folderId;
          //   } else {
          //     this.filteredResourcess = this.resourcesList.filter(
          //       (resource) => resource.parent_folder === null
          //     );
          //     this.filteredResourcess.forEach((resource, index) => {
          //       resource['index'] = index + 1;
          //     });
          //     this.selectedRootFolder = null;
          //   }
          //   this.handleAllCheckstate(this.filteredResourcess);
          // });
          this.isLoading = false;
          this.showLoad = false;
        },
        (error) => {
          this.showLoad = false;
          console.log('ERROR', error);
        }
      );
  }
  // getResources(): void {
  //   this.resourceService.getResources().then((results) => {
  //     this.resourceCopy = this.resourceService.resourcesList;
  //     this.resourcesList = this.resourceService.resourcesList.filter(
  //       (resource) => resource.is_deleted === 0
  //     );
  //     // this.resourceService.getResources().then((results) => {
  //     //   this.resourcesList = this.resourceService.resourcesList;
  //     this.filteredResourcess = this.resourcesList.filter(
  //       (resource) => resource.parent_folder === null
  //     );
  //     // this.resourcesList = this.buildResourceHierarchy(this.resourcesList);
  //     this.tableDataRaw = cloneDeep(this.filteredResourcess);
  //     this.route.queryParams.subscribe((params) => {
  //       const folderId = +params['folderId']; // '+' to convert string to number
  //       if (!isNaN(folderId)) {
  //         this.filteredResourcess = this.resourcesList.filter(
  //           (resource) => resource.parent_folder === folderId
  //         );
  //         this.selectedRootFolder = folderId;
  //       } else {
  //         this.filteredResourcess = this.resourcesList.filter(
  //           (resource) => resource.parent_folder === null
  //         );
  //         this.selectedRootFolder = null;
  //       }
  //     });

  //     // this.filteredResourcess = this.resourcesList.filter(resource => resource.parent_folder === null);
  //     // // this.resourcesList = this.buildResourceHierarchy(this.resourcesList);

  //     // this.tableDataRaw = cloneDeep(this.resourcesList);
  //   });
  // }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
    this.showFilter = !this.showFilter;
  }

  // clickMe(type: 'file' | 'url'): void {
  //   this.updateMode = false;
  //   this.visible = false;
  //   this.createFolderVisible = false;
  //   this.quickViewVisible = !this.quickViewVisible;
  // }

  clickMe(type: 'file' | 'url', param): void {
    this.updateMode = false;
    this.visible = false;
    this.createFolderVisible = false;
    this.quickViewVisible = !this.quickViewVisible;
    if (type === 'file') {
      this.file = param;
      this.isFile = true;
      this.isUrl = false;
    } else if (type === 'url') {
      this.url = param;
      this.isFile = false;
      this.isUrl = true;
    }
  }

  updateAllChecked(): void {
    this.indeterminate = false;
    if (this.allChecked) {
      this.resourcesList.forEach((item) => (item.checked = true));
    } else {
      this.resourcesList.forEach((item) => (item.checked = false));
    }
  }

  updateSingleChecked(): void {
    if (this.resourcesList.every((item) => item.checked === false)) {
      this.allChecked = false;
      this.indeterminate = false;
    } else if (this.resourcesList.every((item) => item.checked === true)) {
      this.allChecked = true;
      this.indeterminate = false;
    } else {
      this.indeterminate = true;
    }
  }

  openDetailView(resourceId: number, event: any = null): void {
    this.detailVisible = true;
    let detailsExist = this.resourcesList.find((obj) => obj.id === resourceId);
    if (detailsExist) {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        detailsExist.path
      );
      this.resourceDetail = { ...detailsExist };
    }
  }

  navigateToResource(id: number) {
    this.router.navigate(['resource', id], {
      state: { resourceList: this.resourcesList },
    });
  }

  // hideAddResourceDrawer() {
  //   this.quickViewVisible = !this.quickViewVisible;
  // }

  hideAddResourceDrawer(showAlert = 0) {
    if (showAlert) {
      this.showConfirm(true);
    } else {
      this.quickViewVisible = !this.quickViewVisible;
    }
  }

  selectedFolder: any;
  parentFolders: any;

  updateComponentState(records: any): void {
    this.filteredFiles = records.children;
    this.resourcesList = this.filteredFiles;
    this.selectedRootFolder = records;
  }

  resetComponentState(): void {
    this.iconVisible = false;
    this.navigationStack = [];
    this.filteredFiles = [];
    this.resourcesList = [];
    this.selectedRootFolder = null;
  }

  resetStateAfterNavigation(): void {
    this.currentPage = 1; // Reset to first page when navigating to a file
    this.hasMore = true; // Reset hasMore to true for new folder

  }
  getFileIcon(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();

    switch (fileExtension) {
      case 'pdf':
        return 'file-pdf';
      case 'doc':
      case 'docx':
        return 'file-word';
      case 'xls':
      case 'xlsx':
        return 'file-excel';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'svg':
      case 'gif':
        return 'file-image';
      case 'mp4':
      case 'mov':
      case 'avi':
        return 'file';
      default:
        return 'file-unknown';
    }
  }

  open(): void {
    this.resetResourceFolderForm();
    this.visible = false;
    this.createFolderVisible = true;
    this.quickViewVisible = false;
    this.updateModes = false; //FOLDER

  }

  hideCreateFolderDrawer() {
    this.createFolderVisible = false;
    this.resetResourceFolderForm();
  }

  resetResourceFolderForm(): void {
    this.resourceFolderForm.reset();
    this.updateModes = false; //FOLDER
    this.updateResourceId = undefined;
    this.rawUpdateData = {};
    this.resourceFolderForm.patchValue({position: 1});
    this.originalFormValue = this.resourceFolderForm.value; //latest
  }

  resetResourceUpdateForm(): void {
    const tagIds = this.rawUpdateData.tag.map((tag) => tag.tag_id);

    this.resourceFolderForm.patchValue({
      resource_name: this.rawUpdateData.resource_name,
      position: this.rawUpdateData.index,
    });

    this.resourceFolderForm.controls.tag.setValue(tagIds);
  }

  submitFolder() {
    try {
   
    this.archived = false;
    this.isArchived = false;
    this.isLoading = true;
    let obj = {
      ...this.resourceFolderForm.value,
      is_folder: 1,
    };
    obj.target_index = obj.position;

    console.log("this is object", obj);
          
    if(!obj.position){
      throw new Error("Enter valid position!");
    }
    if(obj.resource_name.toLowerCase() == 'heaters'){
      throw new Error("Folder name 'Heaters' is reserved and cannot be used.");
    }

    if (this.selectedRootFolder) {
      obj.parent_folder = this.selectedRootFolder;
    }
    this.webapi.requestJson('addResource', obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', response['message']);

        this.currentPage = 1; // Reset to first page after deletion
        this.selectedRootFolder = this.getCurrentFolderId(); // Reset selected root folder
        this.getResourceList({ filters: [] });
        // this.applyFilters();
        // this.receiveFormFromChild(response.data[0])

        // this.getResources();
        // this.getMetadata();

        this.hideCreateFolderDrawer();
      },
      (error) => {
        this.isLoading = false;
        this.createNotification(
          'error',
          '',
          'An error occurred. Please try again later.'
        );
      }
    );

    } catch (error) {

      console.log("this is error", error);
      this.isLoading = false;
      if (error instanceof Error) {
        this.createNotification('error', '', error.message);
      } else {
        this.createNotification(
          'error',
          '',
          'An unexpected error occurred. Please try again later.'
        );
      }

    }
  }

  isCategoryDisabled(): boolean {
    return this.isCategoryAutofilled;
  }

  fillEditResource(data): void {
    console.log('this is data', data);
    if (data.is_folder) {
      this.open();
      this.updateModes = true;
      this.resourceId = data.resource_id;
      // this.getMetadata();
      const tagIds = data.tag.map((tag) => tag.tag_id);
      this.resourceFolderForm.patchValue({
        resource_name: data.resource_name,
        position: data.index
      });

      this.resourceFolderForm.controls.tag.setValue(tagIds);
      this.updateResourceId = data.resource_id;
      this.rawUpdateData = { ...data };
      this.originalFormValue = this.resourceFolderForm.value;
    } else {
      // inportant code
      // this.clickMe();

      console.log('this is resource path', data.resource_path);

      if (data.resource_path) {
        this.clickMe('file', 'fileParam');
      } else {
        console.log('inside URL else case');
        this.clickMe('url', 'urlParam');
      }
      this.updateMode = true;
      this.fillEditResourceData = data;
      // this.originalFormValue = this.resourceForm.value;
    }
  }

  updateFolder() {

    try {
      
    
    this.isLoading = true;
    let obj = {
      resource_id: this.resourceId,
      ...this.resourceFolderForm.value,
    };
    obj.target_index = obj.position;

    console.log("this is object", obj);
          
    if (!obj.target_index){
      throw new Error("Enter valid position!");
    }
      if (obj.resource_name.toLowerCase() == 'heaters') {
        throw new Error("Folder name 'Heaters' is reserved and cannot be used.");
      }

    
    this.webapi.requestJson('updateResource', obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', response['message']);

        this.currentPage = 1; // Reset to first page after deletion
        this.selectedRootFolder = this.getCurrentFolderId(); // Reset selected root folder
        this.getResourceList({ filters: [] });

        // this.receiveFormFromChild(response.data[0])
        // this.getResources();
        // this.getMetadata();
        this.hideCreateFolderDrawer();
      },
      (error) => {
        this.isLoading = false;
        this.createNotification(
          'error',
          '',
          'An error occurred. Please try again later.'
        );
      }
    );
    } catch (error) {
      this.isLoading = false;

      console.log("Error:",error)

      //display error as toast
      this.createNotification(
        'error',
        '',
        error.message
      );

    }
  }

  reorderResource(resourceId, newPosition) {
    console.log('resourceId ==>, newPosition ==>', resourceId, newPosition);

    this.isLoading = true;
    this.showLoad = true;
    if (!resourceId || !newPosition) {
      throw new Error('Please try again!');
    }
    let obj = {
      resource_id: resourceId,
      target_index: newPosition,
      parent_folder: this.selectedRootFolder,
    };
    console.log('reorder objecte', obj);
    this.webapi.requestJson('reorderResource', obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        this.showLoad = false;

        this.createNotification('success', '', response['message']);
        // this.getResourceList({ filters: [] });
        // if(this.isNormalization(this.filteredResourcess)){
        //   this.apiCountNormalization();
        // }
        // this.getResources();
        // this.getMetadata();
        // this.hideCreateFolderDrawer();
        this.isLoading = false;
        this.showLoad = false;
      },
      (error) => {
        this.isLoading = false;
        this.showLoad = false;

        this.createNotification(
          'error',
          '',
          'An error occurred. Please try again later.'
        );
      }
    );
  }

  receiveFormsFromChild(form: FormGroup) {}

  applySearchFilter(resources: any[]): any[] {
    const isSearchTermEmpty = !this.searchTerm.trim();

    if (isSearchTermEmpty) {
      return resources;
    } else {
      return resources.filter((resource) =>
        this.resourceMatchesSearchTerm(resource)
      );
    }
  }

  resourceMatchesSearchTerm(resource: any): boolean {
    const searchTermLowerCase = this.searchTerm.toLowerCase();
    return (
      resource.resource_name.toLowerCase().includes(searchTermLowerCase) ||
      // (resource.size &&
      //   resource.size.toLowerCase().includes(searchTermLowerCase)) ||
      // (resource.size &&
      //   resource.size.toString().toLowerCase().includes(searchTermLowerCase)) ||
      (resource.uploaded_date &&
        resource.uploaded_date
          .toString()
          .toLowerCase()
          .includes(searchTermLowerCase)) ||
      (resource.category_name &&
        resource.category_name.toLowerCase().includes(searchTermLowerCase)) ||
      this.groupMatchSearchTerm(resource.group_names) ||
      this.tagsMatchSearchTerm(resource.tag)
    );
  }

  tagsMatchSearchTerm(tag: any[]): boolean {
    return tag.some((tag) =>
      tag.tag_name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }
  //assignment field search function
  groupMatchSearchTerm(groups: any[]): boolean {
    return groups.some((group) =>
      group.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  onKeyUp(query: string): void {
    this.searchTerm = query;
    // if (this.selectedRootFolder !== null) {
    //   this.filteredResourcess = this.resourcesList.filter(
    //     (resource) => resource.parent_folder === this.selectedRootFolder
    //   );
    // } else {
    //   this.filteredResourcess = this.resourcesList.filter(
    //     (resource) => resource.parent_folder === null
    //   );
    // }
    //currenly this search is only applied for current level, Need to do this online
    this.filteredResourcess = this.resourcesList;
    this.filteredResourcess = this.applySearchFilter(this.filteredResourcess);
  }

  pushFilesAndSubfolders(folder: any): void {
    if (folder.children && folder.children.length > 0) {
      folder.children.forEach((child) => {
        child.checked = true;
        this.checkedItems.push(child.resource_id);

        if (child.is_folder) {
          this.pushFilesAndSubfolders(child);
        }
      });
    }
  }

  areAllChildrenChecked(folder: any): boolean {
    return this.resourcesList
      .filter((item) => item.parent_folder === folder.resource_id)
      .every((item) => item.checked);
  }

  checkAll(value: boolean): void {
    this.checkedItems = [];
    this.filteredResourcess.forEach((data) => {
      if (data.mixedState) {
        this.updateCheckedStateRecursive(data, value);
      } else {
        this.updateCheckedStateRecursive(data, value);
      }
    });
    let parent_folder_id;
    this.route.queryParams.subscribe((params) => {
      parent_folder_id = +params['folderId'];
    });

    parent_folder_id && this.updateParentCheckedState(parent_folder_id);

    // this.anyChecked = this.resourcesList.some((e) => e.checked);
    // this.allChecked = this.resourcesList.every((e) => e.checked);

    this.anyChecked = this.filteredResourcess.some((e) => e.checked); 
    this.allChecked = this.filteredResourcess.every((e) => e.checked);
    // if (this.allChecked) {
    //   this.indeterminate = false;
    // }
    // else {
    //   this.indeterminate = this.anyChecked && !this.allChecked;
    // }
   
  }

  updateCheckedStateRecursive(resource: any, value: boolean): void {
    resource.checked = value;
    resource.mixedState = false;

    // let childNode = this.resourceCache.get(resource.resource_id);
    // if(childNode){
    //   childNode.data.checked = value;
    //   childNode.data.mixedState = false;
    // }

    if (resource.checked && !this.checkedItems.includes(resource.resource_id)) {
      this.checkedItems.push(resource.resource_id);
    } else if (!resource.checked) {
      const index = this.checkedItems.indexOf(resource.resource_id);
      if (index !== -1) {
        this.checkedItems.splice(index, 1);
      }
    }

    if (resource.is_folder) {
      // const children = this.resourcesList.filter(
      //   (item) => item.parent_folder === resource.resource_id
      // );
      const children = this.getResourceChildrens(resource.resource_id);
      console.log("this is children", children);

      children.forEach((child) => {
        this.updateCheckedStateRecursive(child, value);
      });
    }
  }

  // updateCheckedStateRecursive(resource: any, value: boolean): void {
  //   resource.checked = value;
  //   resource.mixedState = false;

  //   if (resource.checked && !this.checkedItems.includes(resource.resource_id)) {
  //     this.checkedItems.push(resource.resource_id);
  //   } else if (!resource.checked) {
  //     const index = this.checkedItems.indexOf(resource.resource_id);
  //     if (index !== -1) {
  //       this.checkedItems.splice(index, 1);
  //     }
  //   }

  //   if (resource.is_folder) {
  //     const children = this.resourcesList.filter(
  //       (item) => item.parent_folder === resource.resource_id
  //     );

  //     children.forEach((child) => {
  //       this.updateCheckedStateRecursive(child, value);
  //     });
  //   }
  // }
  getResourceChildrens(resourceId) {
    const folderState = this.folderPaginationMap.get(resourceId);
    console.log("this is folderState", folderState);
    const visibleIds = folderState?.loadedResourceIds ?? [];
    const tableData = visibleIds.map(id => this.resourceCache.get(id)?.data).filter(Boolean);
    return tableData || []

  }

  onCheckboxChange(resource: any): void {
    if (resource.checked) {
      this.checkedItems.push(resource.resource_id);
    } else {
      //Found the resource Ids in checkedItems
      const index = this.checkedItems.indexOf(resource.resource_id);

      //If found, remove it from the checkedItems array
      if (index !== -1) {
        this.checkedItems.splice(index, 1);
      }
    }

    if (resource.is_folder) {

      //If resource are loaded then update the checked state of all children

      console.log("this is current resource_id", resource.resource_id);

      console.log("this is folder pagination map", this.folderPaginationMap);
      const folderState = this.folderPaginationMap.get(resource.resource_id);
      console.log("this is folderState", folderState);
      const visibleIds = folderState?.loadedResourceIds ?? [];
      const tableData = visibleIds.map(id => this.resourceCache.get(id)?.data).filter(Boolean);

      if (tableData.length > 0) {

        if (resource.mixedState && resource.checked) {

          tableData.forEach((child) => {
            // Update the checked state of each child based on the resource's checked state
            this.updateCheckedStateRecursive(child, true);
          });

          resource.mixedState = false;
        } else {
          // If the resource is checked, update all children to match the checked state
          tableData.forEach((child) => {
            // Update the checked state of each child based on the resource's checked state
            this.updateCheckedStateRecursive(child, resource.checked);
          });
          this.updateParentCheckedState(resource.parent_folder);

        }

      }
    // =============  OLD LOGIC  START ===================
    // if (resource.checked) {
    //   this.checkedItems.push(resource.resource_id);
    // } else {
    //   const index = this.checkedItems.indexOf(resource.resource_id);
    //   if (index !== -1) {
    //     this.checkedItems.splice(index, 1);
    //   }
    // }

    // if (resource.is_folder) {
    //   const children = this.resourcesList.filter(
    //     (item) => item.parent_folder === resource.resource_id
    //   );

    //   if (resource.mixedState && resource.checked) {
    //     children.forEach((child) => {
    //       this.updateCheckedStateRecursive(child, true);
    //     });

    //     resource.mixedState = false;
    //   } else {
    //     children.forEach((child) => {
    //       this.updateCheckedStateRecursive(child, resource.checked);
    //     });
    //   }
    //   // this.updateParentCheckedState(resource.parent_folder);
    // }


    // =============  OLD LOGIC  END ===================
    }
      this.updateParentCheckedState(resource.parent_folder);

      // this.anyChecked = this.resourcesList.some((e) => e.checked);

      // this.allChecked = this.resourcesList.every((e) => e.checked);

      this.anyChecked = this.filteredResourcess.some((e) => e.checked);

      this.allChecked = this.filteredResourcess.every((e) => e.checked);

      // if (this.allChecked) {
      //   this.indeterminate = false;
      // }
      // else {
      //   this.indeterminate = this.anyChecked && !this.allChecked;
      // }
    
    
  }
  updateParentCheckedState(parentFolderId: any): void {
    // const parentFolder = this.resourcesList.find(
    //   (item) => item.resource_id === parentFolderId
    // );

    const parentFolder = this.resourceCache.get(parentFolderId)?.data;

    console.log("this is parentFolder", parentFolder);
    console.log('thisis parent folder Id', parentFolderId);
    console.log('parentFolder', parentFolder);

    if (parentFolder) {

      const parentFolderResource = this.getResourceChildrens(parentFolderId);
      console.log("this is parentFolderResource", parentFolderResource);

      const hasUncheckedChild = parentFolderResource.some(
        (item) => !item.checked
      );

      const hasCheckedChild = parentFolderResource.some(
        (item) => item.checked
      );

      const hasMixedStateChild = parentFolderResource.some(
        (item) =>  item.mixedState
      );

      const mixedState =
        (hasUncheckedChild && hasCheckedChild) || hasMixedStateChild;
        console.log("this is mixedState of parent Folder id:", parentFolder.resource_name,parentFolderId, mixedState);

      parentFolder.mixedState = mixedState;

      if (!mixedState) {
        parentFolder.checked = hasCheckedChild;
      } else {
        parentFolder.checked = false;
      }

      const index = this.checkedItems.indexOf(parentFolderId);
      if (parentFolder.checked && index === -1) {
        this.checkedItems.push(parentFolderId);
      } else if (!parentFolder.checked && index !== -1) {
        this.checkedItems.splice(index, 1);
      }

     


      this.updateParentCheckedState(parentFolder.parent_folder);
    }
  }

  // private getParentFolderById(parentFolderId: any): any {
  //   return this.resourcesList.find((folder) => folder.id === parentFolderId);
  // }

  // recursiveSetCheckedFalse(parentFolderId: number): void {
  //   const parentFolder = this.getParentFolderById(parentFolderId);

  //   if (parentFolder) {
  //     parentFolder.checked = false;

  //     if (parentFolder.parent_folder !== null) {
  //       this.recursiveSetCheckedFalse(parentFolder.parent_folder);
  //     }
  //   }
  // }

  deleteResource(resourceId: any = null, multi = false): void {
    this.showLoad = true;
    this.isLoading = true;

    let obj: any = {};
    obj.resource_id = obj.resource_id || []; // Ensure resource_id is initialized as an array

    let resourceThumbnail: any = [];
    let resourcePath: any = [];



    if (!multi) {
      if (resourceId.checked || resourceId.mixedState) {
        obj.resource_id = [...this.checkedItems];
      } else {
        let childrenIdsToDelete = this.getAllChildrenIds(
          resourceId.resource_id
        );
        obj.resource_id = [resourceId.resource_id, ...childrenIdsToDelete];
      }
    } else {
      this.filteredResourcess.forEach((resource) => {
        if (
          resource.checked &&
          obj.resource_id &&
          !obj.resource_id.includes(resource.resource_id)
        ) {
          let childrenIds = [];
          obj.resource_id.push(resource.resource_id);
          // Get all children Ids , if/ folder is selected
          if (resource.is_folder) {
            childrenIds = this.getAllChildrenIds(resource.resource_id);
            obj.resource_id = [...obj.resource_id, ...childrenIds];
          }
          // else{
          //   //store only selected resource id if there are not folder
          //   obj.resource_id.push(resource.resource_id);
          // }
        } else if (resource.mixedState) {
          console.log('Addting mixedState ', resource.mixedState);
          obj.resource_id = [...this.checkedItems];
        } else {
          console.log(' No mixed or allchecked ');
          obj.resource_id = [...this.checkedItems];
        }
      });
      console.log('Resource Ids to delete', obj);
      console.log('this is filtered resources', this.filteredResourcess);
      // debugger;

      //filtererd resource remove
      //recheck all the parent folder
      //filter all the parent folder form filterred data
      //send to api
    }
    //set default after fetching all items ID
    this.checkedItems = [];
  

    if (obj.resource_id.length > 0) {
    } else {
      this.isLoading = false;
    }

    this.resourcesList.forEach((resource) => {
      if (
        resource.is_folder === 0 &&
        obj.resource_id &&
        obj.resource_id.includes(resource.resource_id)
      ) {
        resource.resource_thumbnail &&
          resourceThumbnail.push(resource.resource_thumbnail);
        resource.resource_path && resourcePath.push(resource.resource_path);
        console.log('inside the loop');
      }
    });
    // console.log("parent folder arr", parent_folderIds);
    console.log('This is obj', obj);
    console.log('This is parameter before passing into AWs function');
    console.log(resourcePath, resourceThumbnail);

    if (resourcePath.length > 0 || resourceThumbnail.length > 0) {
      this.awsService
        .deleteAndCheckFile(resourcePath, resourceThumbnail)
        .then((data) => {
          console.log('This is data after AWS delete', data);
          this.webapi.requestJson('deleteResource', obj).subscribe(
            (data) => {
              let response = JSON.parse(data.body);
              this.createNotification('success', '', 'Deletion successful.');
              this.currentPage = 1; // Reset to first page after deletion
              this.selectedRootFolder =  this.getCurrentFolderId(); // Reset selected root folder
              this.getResourceList({ filters: [] });
              console.log("this is obj after deletion", obj);

              // obj.resource_id.forEach((resource) => {

              //   this.deleteResourceFromCache(resource);
              // })
            
              this.anyChecked = false;
              obj = {};
              this.isLoading = false;
              this.showLoad = false;
            },
            (error) => {
              this.isLoading = false;
              this.showLoad = false;
              this.createNotification(
                'error',
                '',
                'An error occurred. Please try again later.'
              );
              this.getResourceList({ filters: [] });
              obj = {};
            }
          );
        })
        .catch((error) => {
          this.isLoading = false;
          this.showLoad = false;
          this.createNotification(
            'error',
            '',
            'Resource(s) not deleted, please try again!'
          );
          // this.getResourceList({ filters: [] });
        });
    } else {
      console.log('Else part obj', obj);
      this.webapi.requestJson('deleteResource', obj).subscribe(
        (data) => {
          let response = JSON.parse(data.body);
         
          this.createNotification('success', '', 'Deletion successful.');

          this.currentPage = 1; // Reset to first page after deletion
          this.selectedRootFolder = this.getCurrentFolderId(); // Reset selected root folder
          this.getResourceList({ filters: [] });

          // this.getResourceList({ filters: [] });
          console.log("this is obj after deletion", obj);
          // obj.resource_id.forEach((resource) => {

          //   this.deleteResourceFromCache(resource);
          // })
          this.isLoading = false;
          this.showLoad = false;

          this.anyChecked = false;
          obj = {};
        },
        (error) => {
          this.isLoading = false;
          this.showLoad = false;
          this.createNotification(
            'error',
            '',
            'An error occurred. Please try again later.'
          );
          this.getResourceList({ filters: [] });
          obj = {};
        }
      );
    }

    //get current resource parent folder id
    const parentId = this.resourceCache.get(resourceId)?.parent_id;

    //delete the resourceId data from resourcecache
    obj.resource_id && obj.resource_id.forEach((resId) => {
      this.resourceCache.delete(resId);
      this.folderPaginationMap.delete(resId);
      console.log("CLEAR ALL sources from cache", resId);
      this.updateParentCheckedState(parentId)
    })
    //pass current resource's parentFolder
  }

  getAllChildrenIds(resourceId: number): number[] {
    let childIds: number[] = [];

    const getChildren = (parentId: number) => {
      const children = this.resourcesList.filter(
        (resource) => resource.parent_folder === parentId
      );

      children.forEach((child) => {
        childIds.push(child.resource_id);
        getChildren(child.resource_id);
      });
    };

    getChildren(resourceId);

    return childIds;
  }

  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }

  // Remove the resource from filtereresource and resourceCache map after delete (Only parent folder from frontend)
  deleteResourceFromCache(resourceId): void {
    // Remove from filteredResourcess
    this.filteredResourcess = this.filteredResourcess.filter(
      (resource) => resource.resource_id !== resourceId
    );

    //Update the parent folder check status after delete
    const parentFolderId = this.resourceCache.get(resourceId)?.data?.parent_folder;
    if (parentFolderId !== null) {
      this.updateParentCheckedState(parentFolderId);
    }
    
    // Remove from resourceCache
    this.resourceCache.delete(resourceId);

    // Remove from folderPaginationMap if it exists
    if (this.folderPaginationMap.has(resourceId)) {
      this.folderPaginationMap.delete(resourceId);
    }

    // Optionally, you can also remove the resource from resourcesList if needed
    this.resourcesList = this.resourcesList.filter(
      (resource) => resource.resource_id !== resourceId
    );

    //reset indexing
    // this.filteredResourcess.forEach((resource, index) => {
    //   resource.index = index + 1;
    // });
    this.renderData()
  }
  // clickSwitch(item): void {
  //   if (!this.loadingSwitch) {
  //     const modal = this.modal.confirm({
  //       nzTitle: 'Are you sure you want to mark this resource as inactive?',
  //       nzContent: '',
  //       nzOkText: 'OK',
  //       nzCancelText: 'Cancel',
  //       nzOnOk: () => {
  //         this.updateToggleState(item);
  //       },

  //     });

  //     modal.afterClose.subscribe((result) => {
  //       if (!result) {
  //       }
  //     });
  //   }
  // }

  // updateToggleState(item) : void {
  //   // if (!this.loadingSwitch) {
  //     let obj;
  //     // this.loadingSwitch = true;
  //     let childrenIdsToChangeActive = this.getAllChildrenIds(item.resource_id);
  //     obj = {
  //       resource_id: [item.resource_id, ...childrenIdsToChangeActive],
  //       is_active: !item.is_active,
  //     };

  //     this.webapi.requestJson('updateStatus', obj).subscribe(
  //       (data) => {
  //         const response = JSON.parse(data.body);
  //         this.loadingSwitch = false;
  //         this.createNotification('success', '', response['message']);
  //         this.getResourceList({ filters: [] });
  //       },
  //       (error) => {
  //         console.error('Error updating resource status', error);
  //       },
  //       () => {
  //         this.loadingSwitch = false;
  //       }
  //     );
  //   // }
  // }

  clickSwitch(event, item): void {
    // Prevent propagation
    event.stopPropagation();

    if (!this.loadingSwitch && !this.isArchived) {
      let nzTitle: string;
      if (item.is_active) {
        nzTitle = 'Are you sure you want to mark this resource as inactive?';
      
      
      } else {
        nzTitle = 'Are you sure to make this resource as active?';
       

      }

      const modal = this.modal.confirm({
        nzTitle: nzTitle,
        nzContent: '',
        nzOkText: 'OK',
        nzCancelText: 'Cancel',
        nzCentered: true,
        nzOnOk: () => {
          this.loadingSwitch = true;
          return new Promise<void>((resolve, reject) => {
            this.updateToggleState(item, resolve, reject);
          });
        },
      });

      modal.afterClose.subscribe((result) => {
        if (!result) {
          console.log('Update status canceled');
        }
      });
    }
  }

  updateToggleState(item, resolve, reject): void {
    let obj;
    let childrenIdsToChangeActive = this.getAllChildrenIds(item.resource_id);
    obj = {
      resource_id: [item.resource_id, ...childrenIdsToChangeActive],
      is_active: !item.is_active,
    };

    this.webapi.requestJson('updateStatus', obj).subscribe(
      (data) => {
        const response = JSON.parse(data.body);
        this.createNotification('success', '', response['message']);
      
        // this.getResourceList({ filters: [] });

        //inactive the resource
        let currentResource = this.resourceCache.get(item.resource_id)?.data;
        if (currentResource && item.is_active) {
          currentResource.is_active = false;
        } else {
          currentResource.is_active = true;
        }
        console.log("this is currentResource", currentResource)
        this.loadingSwitch = false;
        resolve();
      },
      (error) => {
        console.error('Error updating resource status', error);
        this.loadingSwitch = false;
       
        reject();
      },
      () => {
        this.loadingSwitch = false;
      }
    );
  }

  filtersObject: any = {
    isUsedInLast30Days: false,
    active: false,
    archived: false,
  };

 

  clickFilter() {
    // this.getResourceList({ filters: [] });
    this.filterVisible = false;

    if (this.appliedFilters && this.appliedFilters.length > 0) {
      // this.isUsedInLast30Days = this.appliedFilters.some(filter => filter.values.includes('0'));
      this.active = this.appliedFilters.some((filter) =>
        filter.values.includes('1')
      );
      this.archived = this.appliedFilters.some((filter) =>
        filter.values.includes('2')
      );
    } else {
      // this.isUsedInLast30Days = false;
      this.active = false;
      this.archived = false;
      this.isArchived = false;
    }
  }

  applyFilters() {
    this.appliedFilters = [];

    // if (this.isUsedInLast30Days) {
    //   this.appliedFilters.push({ key: 'status', values: ['0'] });
    //   this.filterVisible = false;
    // }
    // Active = 1
    // Archived = 2

    if (this.active) {
      this.appliedFilters.push({ key: 'status', values: ['1'] });
      this.filterVisible = false;
      this.isArchived = false;
    }

    if (this.archived) {
      this.appliedFilters.push({ key: 'status', values: ['2'] });
      this.filterVisible = false;
      this.isArchived = true;
    }

    this.filterVisible = false;
    this.resourceCache.clear(); // Clear the cache before applying filters
    this.folderPaginationMap.clear(); // Clear the pagination map before applying filters
    this.filteredResourcess = [];
    this.currentPage = 1; // Reset to first page when applying filters
    this.selectedRootFolder = this.getCurrentFolderId(); // Reset selected root folder when applying filters
    this.folderIndexMap.clear(); // Clear the folder index map before applying filters
    this.getResourceList({ filters: this.appliedFilters });
  }

  resetSearch() {
    this.searchTerm = '';
    // this.filteredResourcess = this.resourcesList.filter((resource) =>
    //   this.selectedRootFolder !== null
    //     ? resource.parent_folder === this.selectedRootFolder
    //     : resource.parent_folder === null
    // );
    // this.filteredResourcess = [...this.resourcesList];
    this.resourceCache.clear()
    this.folderPaginationMap.clear();
    this.filteredResourcess = [];
    this.folderIndexMap.clear();
    this.currentPage = 1; // Reset to first page when resetting search
    this.selectedRootFolder = this.getCurrentFolderId(); // Reset selected root folder when resetting search
    this.getResourceList({ filters: [] });

    // this.renderData(() => {
    //   // After DOM is updated, restore scroll
    //   setTimeout(() => {
    //     const previousScrollTop = this.scrollPositionMap.get(this.selectedRootFolder) || 0;
    //     this.scrollContainerRef.nativeElement.scrollTop = previousScrollTop;
    //   }, 0); // adjust delay if necessary
    // })
  }

  getMoreTagsContent(tags): string[] {
    return tags.slice(2).map((tag) => tag.tag_name);
  }

  moreTagsContent: string[];

  updateMoreTagsContent(tags): void {
    this.moreTagsContent = this.getMoreTagsContent(tags);
  }

  resetMoreTagsContent(): void {
    this.moreTagsContent = [];
  }

  cancel(): void {
    console.log('cancel');
  }

  
  drop(event: CdkDragDrop<any[]>): void {

    //Only more then 1 items are allowed to drag drop calculation
    console.log("Event data", event);
    if (this.filteredResourcess.length > 1) {
      if (event.previousIndex !== event.currentIndex) {
        console.log("this is previousINdex",event.previousIndex);
        console.log("this is previousINdex",event.currentIndex);
        console.log("this is abovePos",this.filteredResourcess[event.currentIndex - 1])
        console.log("this is belowPos",this.filteredResourcess[event.currentIndex])
        const resourceId = this.filteredResourcess[event.previousIndex].resource_id;
        console.log("this is resourceId",resourceId);
        console.log("this is resource", this.filteredResourcess[event.previousIndex])
       

        //move items - build in method
        moveItemInArray(
          this.filteredResourcess,
          event.previousIndex,
          event.currentIndex
        );

        // Clone the array to trigger change detection
        // this.filteredResourcess = [...this.filteredResourcess];
       
        this.resetIndex();
        this.reorderResource(resourceId, event.currentIndex + 1)
      }
    }
  }


  // apiCountNormalization() {
    
  //   let obj = {
  //     parentFolderId : this.filteredResourcess[0].parent_folder
  //   }
  //   console.log(obj);
  //   this.showLoad = true;
  //   this.webapi
  //     .requestJson('resourceNormalization',obj)
  //     .subscribe(
  //       (data) => {
  //         this.isLoading = false;
  //         this.showLoad = false;
  //         this.getResourceList({ filters: [] });
  //       },
  //       (error) => {
  //         this.showLoad = false;
  //         console.log('ERROR', error);
  //       }
  //     );
  // }


  resetIndex() {
    console.log('Before resetIndex', this.filteredResourcess);
    this.filteredResourcess = this.filteredResourcess
      .map((resource, index) => {
        return { ...resource, index: index + 1 };
      })
      .sort((a, b) => a.index - b.index);
    console.log('AFter resetIndex', this.filteredResourcess);
  }

 
  noMoreData = false;

  // onScrollDown(event: Event): void {
  //   console.log("this is current page", this.currentPage, this.hasMore);
  //   if ((this.isLoading || this.showLoad) || !this.hasMore) {
  //     console.log('Loading or no more data, stopping');
  //     return;
  //   }
  //   console.log("Before loadnext page");
  
  //   this.loadNextPage();

  //   console.log("this is filtered Resource while scroll", this.filteredResourcess);
    
  // }
  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;             // how far scrolled from top
    const scrollHeight = target.scrollHeight;       // full height of scrollable content
    const clientHeight = target.clientHeight;       // visible area

    // console.log('scrollTop:', scrollTop);
    // console.log('scrollHeight:', scrollHeight);
    // console.log('clientHeight:', clientHeight);

    // console.log('Reached bottom?', scrollTop + clientHeight + 10 >= scrollHeight);
    // console.log("this is selectedRootFolder");

    let selectedRootFolderId = this.getCurrentFolderId();
    this.hasMore = !this.folderPaginationMap.get(selectedRootFolderId)?.isLastPage;
    
    console.log("Current RESOURCE COUNT inside ", this.currentResourceCount);

    if (scrollTop + clientHeight + 10 >= scrollHeight){
      console.log('Reached bottom, loading next page...');
      if ((this.isLoading || this.showLoad) || !this.hasMore) {
        // console.log("this is hasMore", this.hasMore);
        // console.log("this is isLoading", this.isLoading);
        // console.log("this is showLoad", this.showLoad);
        console.log('Loading or no more data, stopping');
        return;
      }
      this.loadNextPage();
    }
  }

  applySearch(value:any) {

    if(value.trim() || this.appliedFilters.length > 0){
      this.searchTerm = value;
      this.currentPage = 1;
      
      this.filteredResourcess = [];
      this.getResourceList({ filters: [] },null,"search");
    }
    console.log("this is value", value);
  }


  syncFilteredResources(){
    console.log("this is sortColumn", this.ResourceTableRef);
    if (this.ResourceTableRef){
      console.log("Inside the syncfilters")
      this.filteredResourcess = [...this.ResourceTableRef.data];
    }
  }
  onHeaderClick() {
    console.log("Hello",this.ResourceTableRef);
    // let the table apply its internal sort first
    setTimeout(() => this.syncFilteredResources(), 0);
  }

  sortColumn(column): void {
    console.log("This is reference", column)
    console.log("this is column", column);
    if (!column || !column.sortOrder || !column.sortFn) {
      return; // nothing to sort
    }

    this.filteredResourcess.sort((a, b) => {
      const result = column.sortFn!(a, b);
      return column.sortOrder === 'ascend' ? result : -result;
    });
  }


  clickSwitchFileShare(event,resource):void{
    event.preventDefault();

    if(resource.is_folder){
      console.log("Folders can not shareable, only files can be shared");
      return 
    }
    const newValue = !resource.is_shareable;
    // Show confirmation modal
    this.modal.confirm({
      nzTitle: 'Confirm Shareability Change',
      nzContent: newValue // true + -negative => false ; false + -negative => true
        ? 'You are about to make this resource shareable. This means anyone with access can view or download it. Do you want to proceed?'
        : 'You are about to disable sharing for this resource. It will no longer be accessible to others. Do you want to proceed?',
      nzOkText: 'Yes',
      nzCentered: true,
      nzCancelText: 'No',
      nzOnOk: () => {

        //Update the filteredResourcess state
        this.filteredResourcess = this.filteredResourcess.map((res) => {
          if (res.resource_id === resource.resource_id) {
            return {
              ...res,
              is_shareable: newValue
            };
          }
          else{
            return res;
          }
        }
        )

        //Update the resourceCache value
        const currResource = this.resourceCache.get(resource.resource_id)?.data;
        currResource.is_shareable = newValue;
        return new Promise((resolve, reject) => {
          this.updateFileShareStatus(resource, newValue,resolve, reject);
        });
      }
     
    })
    
    
  }

  updateFileShareStatus(resource,newValue,resolve, reject): void {

    this.isLoading = true;
    //trigger the file share status api 
    let obj = {
      resource_id: resource.resource_id,
      is_shareable: newValue
    };
    this.webapi.requestJson('updateFileShareStatus', obj).subscribe(
      (data) => {
        const response = JSON.parse(data.body);
        this.createNotification('success', '', response['message']);
        // Optionally, you can refresh the resource list or update the UI
        this.isLoading = false;
        resolve();

      }
      ,
      (error) => {
        console.error('Error updating file share status', error);
        this.createNotification('error', '', 'An error occurred while updating share status. Please try again later.');
        this.isLoading = false;
        reject();
      }

    );
    

  }


  private scrollInterval: any;

  onDragMoved(event: CdkDragMove<any>) {
    console.log("This is drag moved event", event);
    if (!this.scrollContainerRef) return; // safe guard
    const container = this.scrollContainerRef.nativeElement;

    if (!container) return; // extra safety

    console.log("this is container");


    const rect = container.getBoundingClientRect();
    const pointerY = event.pointerPosition.y;

    const scrollSpeed = 10;
    const threshold = 50;
    console.log("this is rect", rect);
    console.log("pointerY < rect.top + threshold", pointerY < rect.top + threshold)
    if (pointerY < rect.top + threshold) {
      this.startScroll(-scrollSpeed);
    } else if (pointerY > rect.bottom - threshold) {
      this.startScroll(scrollSpeed);
    } else {
      this.stopScroll();
    }
  }


  private startScroll(amount: number) {
    console.log("This is start scroll", amount);
    if (this.scrollInterval) return;
    const container = this.scrollContainerRef.nativeElement;

    this.scrollInterval = setInterval(() => {
      container.scrollTop += amount;
    }, 20);
  }

  private stopScroll() {
    console.log("This is stoping scroll");

    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }

  onDragStarted(event): void {
    event.source.element.nativeElement.classList.add('dragging-item');
  }

  onDragEnded(event): void {
    event.source.element.nativeElement.classList.remove('dragging-item');
    this.stopScroll();
  }

  onSortChange(params): void {
    // 'sortInfo.key' is the column key (e.g., 'resourceName', 'dateCreated')
    // 'sortInfo.value' is the sort direction ('ascend', 'descend')

    console.log('Sort parmas:',  params);
    const { pageSize, pageIndex, sort, filter } = params;
    const currentSort = sort.find(item => item.value !== null);
    let sortField = (currentSort && currentSort.key) || null;
    let sortOrder = (currentSort && currentSort.value) || null;

    sortOrder = sortOrder === 'ascend' ? 'asc' : sortOrder === 'descend' ? 'desc' : null;
    console.log("this is sortField", sortField);
    this.sortOrderR = sortOrder;
    this.sortField = sortField;

    // Reset to the first page and clear data
    this.currentPage = 1;
    this.filteredResourcess = [];
    this.resourceCache.clear();
    this.folderPaginationMap.clear();
    this.folderIndexMap.clear();
    this.hasMore = true;

    // Make the API call with the sorting parameters
    this.getResourceList({ filters: [] }, null, null);
  }

}


